import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { usePostOrderVoid } from '@services/global/orders/postVoid';

export const useOrderVoid = (
  id: string,
  merchantId: string,
  max: number,
  callback?: () => void,
) => {
  const { t } = useTranslation('app');
  const schema = z.object({
    amount: z.coerce
      .number()
      .nonnegative()
      .lte(max, {
        message: t('form.amount.upperLimit', { limit: max }),
      }),
  });

  const defaultValues = {
    amount: max,
  };

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: defaultValues,
  });

  const onSuccess = () => {
    if (callback) callback();
    form.reset();
  };

  const { mutate, isPending, error } = usePostOrderVoid({
    id: id,
    callback: onSuccess,
    setError: form.setError,
  });

  const onSubmit = async (values: z.infer<typeof schema>) => {
    mutate({ ...values, merchantId });
  };

  return {
    form,
    onSubmit,
    isPending,
    error,
  };
};
